



























































































import { defineComponent, computed, PropType } from '@vue/composition-api';
import { ExclamationIcon } from '@vue-hero-icons/outline';
import { Toggle } from '@/app/components';
import { FieldPath } from '../../components';
import { VPopover } from 'v-tooltip';
import { EncryptionFieldConfiguration } from '../../types/encryption.type';
import { AlrternateNames } from '../../types';

export default defineComponent({
    name: 'FieldView',
    components: { FieldPath, Toggle, ExclamationIcon, VPopover },
    props: {
        field: {
            type: Object as PropType<EncryptionFieldConfiguration>,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isFinalized: {
            type: Boolean,
            default: false,
        },
        modified: {
            type: Boolean,
            default: false,
        },
        alternateName: {
            type: Object as PropType<AlrternateNames[string]>,
            default: null,
        },
        showAlternateNaming: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const fieldClicked = () => {
            if (!props.isFinalized) {
                emit('toggle-selection');
            }
        };

        const updateIndex = () => {
            emit('update-index');
        };

        const tooltipMessage = computed(() => {
            if (props.field.dropped) return 'Field has been dropped in a previous step';
            if (!props.field.indexES) return `Field cannot be indexed`;
            return null;
        });

        const toggleColor = computed(() => {
            if (props.isFinalized && props.field.index) {
                return 'bg-primary-400';
            }
            if (!props.isFinalized && props.field.index) {
                return 'bg-primary-600';
            }
            if ((props.isFinalized || !props.field.indexES) && !props.field.index) {
                return 'bg-neutral-200';
            }

            if (!props.isFinalized && props.field.indexES && !props.field.index) {
                return 'bg-neutral-300';
            }
            return '';
        });

        return {
            fieldClicked,
            updateIndex,
            tooltipMessage,
            toggleColor,
        };
    },
});
